module.exports = __webpack_public_path__ + "static/media/airplane-departure.11ef63d3.svg";